import { render, staticRenderFns } from "./damoxing.vue?vue&type=template&id=5fc45954&scoped=true"
import script from "./damoxing.vue?vue&type=script&lang=js"
export * from "./damoxing.vue?vue&type=script&lang=js"
import style0 from "./damoxing.vue?vue&type=style&index=0&id=5fc45954&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc45954",
  null
  
)

export default component.exports